/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-01-05 10:30:50
 *
 *******************************************************/
//@flow
import _ from 'lodash';
import React, { Component } from 'react';
import { InlineError, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { AsyncPaginate } from 'react-select-async-paginate';
import { RenderLabelTooltip } from './render-label-tooltip';
import { selectStyle } from './render-select.style';

type Props = WithI18nProps;

class RenderSelect2Component extends Component<Props> {
  state = {
    cacheUniqs: [1],
    emptyValue: false
  };

  componentWillReceiveProps(nextProps) {
    const { options = [] } = nextProps;
    const { options: optionsPrev = [] } = this.props;

    // Force render component if the options change
    if (_.get(options, '[0].value') !== _.get(optionsPrev, '[0].value')) {
      this.setState({ cacheUniqs: [this.state.cacheUniqs[0] + 1] });
    }

    const preOptionName = optionsPrev.map(option => `${option.name}-${option.updated_at}`).join('');
    const newOptionName = options.map(option => `${option.name}-${option.updated_at}`).join('');
    if (preOptionName !== newOptionName) {
      this.setState({ cacheUniqs: [this.state.cacheUniqs[0] + 1] });
    }
  }
  render() {
    const {
      meta,
      options,
      label,
      tooltip,
      input,
      isDisabled,
      textHelper,
      placeholderEmpty,
      i18n,
      loading
    } = this.props;

    const { emptyValue } = this.state;
    const hasError = !!meta.error && !!meta.touched && !loading;

    let { placeholder } = this.props;
    placeholder =
      _.isEmpty(options) && !loading
        ? placeholderEmpty || i18n.translate('AdminHTML.Common.Empty.select_Placeholder')
        : placeholder;
    return (
      <div className={hasError ? 'Polaris-TextField--error' : 'Polaris-Select-2'}>
        <RenderLabelTooltip label={label} tooltip={tooltip} />
        <AsyncPaginate
          id={input.name}
          loadOptions={this.loadOptions}
          value={input.value}
          onChange={value => {
            input.onChange(value);
          }}
          onBlur={() => {
            if (!input.value || _.isEmpty(input.value)) {
              this.setState({ emptyValue: true });
            } else {
              this.setState({ emptyValue: false });
            }
          }}
          label={label}
          styles={selectStyle}
          placeholder={placeholder}
          maxMenuHeight={150}
          menuPortalTarget={document.body}
          classNamePrefix="BC-Select"
          isDisabled={isDisabled ? true : false}
          cacheUniqs={this.state.cacheUniqs}
          noOptionsMessage={() => i18n.translate('AdminHTML.Common.Empty.reactSelect_NoOptions')}
        />

        {textHelper ? (
          <p style={{ marginTop: '0.25rem' }}>
            <TextStyle variation="subdued">{textHelper}</TextStyle>
          </p>
        ) : (
          ''
        )}
        {meta.error && emptyValue ? <InlineError message={meta.error} /> : ''}
      </div>
    );
  }

  // Wait ms time
  sleep = ms =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, ms);
    });

  // Pagination options
  loadOptions = async (search, prevOptions) => {
    const { options } = this.props;
    if (!_.isEmpty(prevOptions)) {
      await this.sleep(1000);
    }

    let filteredOptions;
    if (!search) {
      filteredOptions = options;
    } else {
      const searchLower = search.toLowerCase();

      filteredOptions = options.filter(({ label }) => label.toLowerCase().includes(searchLower));
    }

    const hasMore = filteredOptions.length > prevOptions.length + 20;
    const slicedOptions = filteredOptions.slice(prevOptions.length, prevOptions.length + 20);

    return {
      options: slicedOptions,
      hasMore
    };
  };
}

export const RenderSelect2 = withI18n()(RenderSelect2Component);
